import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation, Trans } from 'react-i18next';
import "./ReviewYourPhoneNumber.css";

const SubmitErrorModal = (props: any) => {

    const { t } = useTranslation();

    return (

        <Modal
            show={true}
            onHide={() => props.setShowModal(false)}
            backdrop="static"
            keyboard={false}
            centered
            contentClassName="error-modal-content"
        >
            <Modal.Header closeButton>
                <Modal.Title ><b>{t('review_phone.modal.header')}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Trans i18nKey={'review_phone.modal.errorMessage'} values={{ livelyHotline: "(800)733-6632" }}></Trans>
            </Modal.Body>
            <Modal.Footer className='error-modal-footer'>
                <Button className='btn-custom' size='lg' onClick={() => props.setShowModal(false)}>
                    {t('review_phone.modal.btn')}
                </Button>
            </Modal.Footer>
        </Modal>

    )
}

export default SubmitErrorModal